import { createStyle } from "@gluestack-style/react";

export const Pressable = createStyle({
  _web: {
    ":focusVisible": {
      outlineWidth: "2px",
      outlineColor: "$primary700",
      outlineStyle: "solid",
      _dark: {
        outlineColor: "$primary300",
      },
    },
  },
  variants: {
    variant: {
      ghost: {
        ":hover": {
          bg: "$backgroundLight50",
        },
      },
      selectable: {
        ":hover": {
          filter: "brightness(.99)",
          boxShadow: "0 0 2pt 1pt #00000015;",
          borderRadius: 8,
        },
      },
    },
  },
});
